import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from "@/layout/index.vue"
Vue.use(VueRouter)

const routes = [
  {
    path: '/', name: 'layout', component: layout,
    redirect: '/home',
    children: [
      {
        path: '/home', name: 'home', component: () => import('../views/homeView.vue'), meta: {
          title: '主页',
          content: {
            keywords: '越华鹏诚数字科技（山东）有限公司，越华鹏诚，天大越华，危废台账怎么做，什么是电子危废台账，什么是电子危险废物台账',
            description: '越华鹏诚数字科技（山东）有限公司隶属于天大越华子公司，自成立之日起就专心致力于环保信息化、智能化、数字化研发，企业研发的危废终端一站式实现危废全流程可视化跟踪。',
          },
        }
      },//主页
      {
        path: '/about', name: 'about', component: () => import('../views/aboutOursView.vue'), meta: {
          title: '关于我们',
          content: {
            keywords: '越华鹏诚数字科技（山东）有限公司，越华鹏诚，天大越华，危险废物标签怎么做',
            description: '越华鹏诚数字科技（山东）有限公司隶属于天大越华子公司，自成立之日起就专心致力于环保信息化、智能化、数字化研发，企业研发的危废终端一站式实现危废全流程可视化跟踪。',
          },
        }
      },//关于我们
      {
        path: '/contact', name: 'contact', component: () => import('../views/contactView.vue'), meta: {
          title: '联系我们',
          content: {
            keywords: '终端机，危废标签称重一体机，危险废物标签称重一体机，废机油标签，废电池标签，废机油危废标签，废电池危废标签',
            description: '越华鹏诚数字科技（山东）有限公司隶属于天大越华子公司，自成立之日起就专心致力于环保信息化、智能化、数字化研发，企业研发的危废终端一站式实现危废全流程可视化跟踪。',
          },
        }
      },//联系我们
      {
        path: '/news', name: 'news', component: () => import('../views/newsView.vue'), meta: {
          title: '资讯中心',
          content: {
            keywords: '危废台账怎么做，危险废物台账怎么做，危险废物电子台账怎么做',
            description: '越华鹏诚数字科技（山东）有限公司积极参与各大环保展会及社会公益活动，以科技手段带动环保工作效率，为有关部门制定环境保护政策提供更好的参考数据。',
          },
        }
      },//资讯中心
      // 产品中心
      {
        path: '/digitalize', name: 'digitalize', component: () => import('../views/product/digitalizeView.vue'), meta: {
          title: '危废收集数字化管理系统',
          content: {
            keywords: '危废终端机优势，为什么要选择危废终端机，危废标签打印一体机',
            description: '危废收集数字化管理系统是一款利用数字技术对危险废物进行全面、透明、实时的管理的系统。该系统通过收集、存储、跟踪和报告危废信息，实现了危废从产生到处理的全过程监管，提高了危废处理效率，降低了环境风险。',
          },
        }
      },//危废收集数字化管理系统
      {
        path: '/intelligent', name: 'intelligent', component: () => import('../views/product/intelligentView.vue'), meta: {
          title: '固体废物全过程智慧化管理平台',
          content: {
            keywords: '智能化管理，什么是电子危废台账，什么是电子危险废物台账，危险废物台账是什么，危废台账是什么',
            description: '固体废物全过程智慧化管理平台采用现代信息技术进行智能化、透明化和无纸化管理，提高管理水平，降低成本，优化资源利用，减少环境污染，实现固废减量化、资源化和无害化处理的目标。',
          },
        }
      },//固体废物全过程智慧化管理平台
      {
        path: '/unattended', name: 'unattended', component: () => import('../views/product/unattendedView.vue'), meta: {
          title: '无人值守危废库',
          content: {
            keywords: '自动化，危险废物标签打印一体机，危险废物称重打印一体机',
            description: '无人值守危废库是自动化的危废存储设施，采用监控技术和传感器设备，可降低人工操作风险，提高危废处理效率，实现24小时安全监控，确保存储和处理过程符合法规和标准。',
          },
        }
      },//无人值守危废库
      {
        path: '/wasteTerminal', name: 'wasteTerminal', component: () => import('../views/product/wasteTerminalView.vue'), meta: {
          title: '危废终端设备',
          content: {
            keywords: '功能全面，危险废物标签终端机，危险废物标签称重终端机',
            description: '危废终端设备是处理危险废物的设备，可实现快速检测、计量、收集、处置和利用等功能，具有高效、节能、环保等特点，可降低对环境的影响，提高资源利用率，助力固废减量化、资源化和无害化处理的目标。',
          },
        }
      },//危废终端设备
      {
        path: '/details', name: 'details', component: () => import('../views/details.vue'), meta: {
          title: '文章详情',
          content: {
            keywords: '文章详情',
          },
        }
      },//文章详情
    ]
  }

]

const router = new VueRouter({
  routes
})

export default router
